var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24 23.9998C1.15995 20.7238 4.57764e-07 16.4475 0 11.9999C0 7.55239 1.15995 3.27608 3.24 0V23.9998Z",
    fill: "#FF8853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24C20.8174 24 17.7652 22.7357 15.5147 20.4853C13.2643 18.2349 12 15.1826 12 12C12 8.81741 13.2643 5.76516 15.5147 3.51472C17.7652 1.26428 20.8174 1.14421e-06 24 5.24537e-07L24 24Z",
    fill: "#FF8853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23472 21.0582C8.46122 22.3675 9.92588 23.3641 11.52 24V0C9.92588 0.635857 8.46122 1.63247 7.23472 2.94178C4.98428 5.34417 3.72 8.6025 3.72 12C3.72 15.3975 4.98428 18.6558 7.23472 21.0582Z",
    fill: "#FF8853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommIcon);
export default __webpack_public_path__ + "static/media/CommIcon.0e42ae0ac9397786f178d9a9d9627896.svg";
export { ForwardRef as ReactComponent };